import {AxiosResponse} from 'axios'
import {
  APIData,
  APIKeysCreateSuccessResponse,
  APIKeysSuccessResponse,
  Creds,
} from 'interfaces'
import {unwrapAPIError} from 'utils'
import {apiKeysBaseUrl, requestHandler} from '../HTTP'
import {EndPoints, HttpMethods} from '../HTTP/HTTP.types'
import {defaultAPIQueryData} from 'features/Settings/API/constants'

const apiBaseUrl = apiKeysBaseUrl()

const getAPIKeys = async (): Promise<APIData> => {
  try {
    const response: AxiosResponse<APIKeysSuccessResponse> =
      await requestHandler({
        method: HttpMethods.GET,
        url: apiBaseUrl + EndPoints.APIKeys,
      })
    return response?.data?.data || defaultAPIQueryData
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const generateAPIKey = async (name: string): Promise<Creds> => {
  try {
    const response: AxiosResponse<APIKeysCreateSuccessResponse> =
      await requestHandler({
        method: HttpMethods.POST,
        url: apiBaseUrl + EndPoints.APIKeys,
        data: {
          data: {
            cred: {
              name,
            },
          },
        },
      })
    return response.data.data.cred
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

const revokeAPIKeys = async (
  clientId?: string,
): Promise<AxiosResponse<APIData>> => {
  try {
    const path = clientId ? `/${clientId}` : ''
    return await requestHandler<APIData>({
      method: HttpMethods.DELETE,
      url: apiBaseUrl + EndPoints.APIKeys + path,
    })
  } catch (error) {
    const errorValue = unwrapAPIError(error)
    return Promise.reject(errorValue)
  }
}

export const CredsService = {
  getAPIKeys,
  generateAPIKey,
  revokeAPIKeys,
}
